import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";

// ===========================================================
// 🔹 ÍTEMS DE ALQUILER
// ===========================================================

// Traer todos los ítems
export async function getAllItemAlquiler() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getallitemalquiler`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data.result;
}

// Traer ítem por ID
export async function getItemAlquilerById(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getitemalquilerbyid/${id}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data.result;
}

// Insertar ítem
export async function insertItemAlquiler(itemData) {
  const token = getAuthToken();

  // 🔹 Convertir todos los valores de texto a MAYÚSCULA antes de enviar
  const upperData = Object.fromEntries(
    Object.entries(itemData).map(([key, value]) => [
      key,
      typeof value === "string" ? value.toUpperCase() : value,
    ])
  );

  const response = await fetch(`${CALL_API}/insertitemalquiler`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(upperData),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data;
}

// Actualizar ítem
export async function updateItemAlquiler(id, itemData) {
  const token = getAuthToken();

  // 🔹 Convertir todos los valores de texto a MAYÚSCULA antes de enviar
  const upperData = Object.fromEntries(
    Object.entries(itemData).map(([key, value]) => [
      key,
      typeof value === "string" ? value.toUpperCase() : value,
    ])
  );

  const response = await fetch(`${CALL_API}/updateitemalquiler/${id}`, {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(upperData),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data;
}

// Eliminar ítem
export async function deleteItemAlquiler(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/deleteitemalquiler/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data;
}

// ===========================================================
// 🔹 ALQUILERES
// ===========================================================

export async function nuevoAlquiler(dataAlquiler) {
  const token = getAuthToken();

  // 🔹 También guardar campos de texto en mayúscula
  const upperData = Object.fromEntries(
    Object.entries(dataAlquiler).map(([key, value]) => [
      key,
      typeof value === "string" ? value.toUpperCase() : value,
    ])
  );

  const response = await fetch(`${CALL_API}/nuevoalquiler`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(upperData),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data;
}

export async function updateAlquiler(id, dataAlquiler) {
  const token = getAuthToken();

  const upperData = Object.fromEntries(
    Object.entries(dataAlquiler).map(([key, value]) => [
      key,
      typeof value === "string" ? value.toUpperCase() : value,
    ])
  );

  const response = await fetch(`${CALL_API}/updatealquiler/${id}`, {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(upperData),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data;
}

// Obtener alquileres por rango de fechas
export async function getAlquilerByDate(fechainicio, fechafin) {
  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/getalquilerbydate?fechainicio=${fechainicio}&fechafin=${fechafin}`,
    {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data.result;
}

// Obtener alquileres activos
export async function getAlquileresActivos() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getalquileresactivos`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data.result;
}

// Verificar disponibilidad de ítem
export async function checkItemDisponible(iditem) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/checkitemdisponible?iditem=${iditem}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data.disponible;
}
